export default __webpack_public_path__ + "static/media/01_DAIF_Data_03_02_end.06df5e77.jpg";